import { Action, ActionType, PAGES, State } from "./types";

export const initialState: State = {
  page: PAGES.FORM,
};

export const transactionDisputeReducer = (
  state: State,
  action: Action,
): State => {
  switch (state.page) {
    case PAGES.FORM: {
      switch (action.type) {
        case ActionType.ACCOUNT_INFO_LOADED: {
          return {
            ...state,
            accountInfo: action.accountInfo,
          };
        }
        case ActionType.FORM_SUBMITTED: {
          return {
            ...state,
            page: PAGES.SUCCESS,
          };
        }

        default: {
          return state;
        }
      }
    }

    default: {
      return state;
    }
  }
};
